export const formatElementID = (str: string) =>
  str.replace(/[^a-zA-Z0-9-]/g, '-').toLowerCase();
